import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {Tabs} from "@pg-design/tabs-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {PromotionDetail} from "../../promotion/types/PromotionDetail";
import {insertIf} from "../../utils/insert_if";
import {getOfferTypeNamePluralCapital} from "../helpers/OfferType";
import {IOfferDetail} from "../types/IOfferDetail";

interface IProps {
    offer: IOfferDetail;
    refElements: {
        refGallery: React.RefObject<HTMLTableSectionElement | null>;
        refProperties?: React.RefObject<HTMLTableSectionElement | null>;
        refDescription: React.RefObject<HTMLTableSectionElement | null>;
        refPromotions?: React.RefObject<HTMLTableSectionElement | null>;
        refLocation: React.RefObject<HTMLTableSectionElement | null>;
        refContact?: React.RefObject<HTMLTableSectionElement | null>;
    };
    promotions?: PromotionDetail[];
    disableContact?: boolean;
}

const SCROLL_OFFSET = -(80 + 16); // 80px OfferNavBar height + 16px margin

export const OfferBarNavigation = (props: IProps) => {
    const {offer, refElements, promotions, disableContact} = props;

    const {isMobile} = useUserDevice();

    const isApartment = offer.is_holiday_location || offer.is_condohotel;

    return (
        <>
            {!isMobile && (
                <Container as="nav" className={css({mb: 3})} data-testid={OFFER_TEST_IDS.OFFER_VIEW.OFFER_NAVIGATION_SECTION}>
                    <Tabs
                        tabs={[
                            ...insertIf((offer.stats?.properties_count_for_sale ?? 0) > 0 && refElements.refProperties, {
                                title: isApartment ? "Apartamenty" : getOfferTypeNamePluralCapital(offer.type),
                                scrollOffset: SCROLL_OFFSET,
                                scrollId: "nieruchomosci",
                                value: "properties",
                                gtmClick: "Nieruchomości - nawigacja",
                                dataTestId: OFFER_TEST_IDS.OFFER_VIEW.OFFER_NAVIGATION_PROPERTIES_BUTTON
                            }),
                            ...insertIf(promotions && promotions.length > 0 && refElements.refPromotions, {
                                title: "Promocje",
                                scrollOffset: SCROLL_OFFSET,
                                scrollId: "promocje",
                                value: "promotions",
                                gtmClick: "Promocje - nawigacja",
                                dataTestId: OFFER_TEST_IDS.OFFER_VIEW.OFFER_NAVIGATION_PROMOTIONS_BUTTON
                            }),
                            {
                                title: "Opis",
                                scrollOffset: SCROLL_OFFSET,
                                scrollId: "opis",
                                value: "description",
                                gtmClick: "Opis - nawigacja",
                                dataTestId: OFFER_TEST_IDS.OFFER_VIEW.OFFER_NAVIGATION_DESCRIPTION_BUTTON
                            },
                            {
                                title: "Okolica",
                                scrollOffset: SCROLL_OFFSET,
                                scrollId: "okolica",
                                value: "location",
                                gtmClick: "Okolica - nawigacja",
                                dataTestId: OFFER_TEST_IDS.OFFER_VIEW.OFFER_NAVIGATION_LOCATION_BUTTON
                            },
                            ...insertIf(!disableContact, {
                                title: "Kontakt",
                                scrollOffset: SCROLL_OFFSET,
                                scrollId: "kontakt",
                                value: "contact",
                                gtmClick: "Kontakt - nawigacja",
                                dataTestId: OFFER_TEST_IDS.OFFER_VIEW.OFFER_NAVIGATION_CONTACT_BUTTON
                            })
                        ]}
                        variant="contained"
                        fullWidth
                    />
                </Container>
            )}
        </>
    );
};
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {Tabs} from "@pg-design/tabs-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {PromotionDetail} from "../../promotion/types/PromotionDetail";
import {insertIf} from "../../utils/insert_if";
import {getOfferTypeNamePluralCapital} from "../helpers/OfferType";
import {IOfferDetail} from "../types/IOfferDetail";

interface IProps {
    offer: IOfferDetail;
    refElements: {
        refGallery: React.RefObject<HTMLTableSectionElement | null>;
        refProperties?: React.RefObject<HTMLTableSectionElement | null>;
        refDescription: React.RefObject<HTMLTableSectionElement | null>;
        refPromotions?: React.RefObject<HTMLTableSectionElement | null>;
        refLocation: React.RefObject<HTMLTableSectionElement | null>;
        refContact?: React.RefObject<HTMLTableSectionElement | null>;
    };
    promotions?: PromotionDetail[];
    disableContact?: boolean;
}

const SCROLL_OFFSET = -(80 + 16); // 80px OfferNavBar height + 16px margin

export const OfferBarNavigation = (props: IProps) => {
    const {offer, refElements, promotions, disableContact} = props;

    const {isMobile} = useUserDevice();

    const isApartment = offer.is_holiday_location || offer.is_condohotel;

    return (
        <>
            {!isMobile && (
                <Container as="nav" className={css({mb: 3})} data-testid={OFFER_TEST_IDS.OFFER_VIEW.OFFER_NAVIGATION_SECTION}>
                    <Tabs
                        tabs={[
                            ...insertIf((offer.stats?.properties_count_for_sale ?? 0) > 0 && refElements.refProperties, {
                                title: isApartment ? "Apartamenty" : getOfferTypeNamePluralCapital(offer.type),
                                scrollOffset: SCROLL_OFFSET,
                                scrollId: "nieruchomosci",
                                value: "properties",
                                gtmClick: "Nieruchomości - nawigacja",
                                dataTestId: OFFER_TEST_IDS.OFFER_VIEW.OFFER_NAVIGATION_PROPERTIES_BUTTON
                            }),
                            ...insertIf(promotions && promotions.length > 0 && refElements.refPromotions, {
                                title: "Promocje",
                                scrollOffset: SCROLL_OFFSET,
                                scrollId: "promocje",
                                value: "promotions",
                                gtmClick: "Promocje - nawigacja",
                                dataTestId: OFFER_TEST_IDS.OFFER_VIEW.OFFER_NAVIGATION_PROMOTIONS_BUTTON
                            }),
                            {
                                title: "Opis",
                                scrollOffset: SCROLL_OFFSET,
                                scrollId: "opis",
                                value: "description",
                                gtmClick: "Opis - nawigacja",
                                dataTestId: OFFER_TEST_IDS.OFFER_VIEW.OFFER_NAVIGATION_DESCRIPTION_BUTTON
                            },
                            {
                                title: "Okolica",
                                scrollOffset: SCROLL_OFFSET,
                                scrollId: "okolica",
                                value: "location",
                                gtmClick: "Okolica - nawigacja",
                                dataTestId: OFFER_TEST_IDS.OFFER_VIEW.OFFER_NAVIGATION_LOCATION_BUTTON
                            },
                            ...insertIf(!disableContact, {
                                title: "Kontakt",
                                scrollOffset: SCROLL_OFFSET,
                                scrollId: "kontakt",
                                value: "contact",
                                gtmClick: "Kontakt - nawigacja",
                                dataTestId: OFFER_TEST_IDS.OFFER_VIEW.OFFER_NAVIGATION_CONTACT_BUTTON
                            })
                        ]}
                        variant="contained"
                        fullWidth
                    />
                </Container>
            )}
        </>
    );
};
